import { createAction, props } from '@ngrx/store';

export const lockPlatform = createAction(
  '[Lock] Lock Platform',
  props<{ userId?: string; firstName?: string; lastName?: string; overwriteLock: boolean }>()
);
export const lockPlatformCall = createAction('[Lock] Lock Platform call', props<{ userId?: string }>());
export const unlockPlatformCall = createAction('[Lock] Unlock Platform call', props<{ userId?: string }>());
export const unlockPlatform = createAction('[Lock] Unlock Platform', props<{ userId?: string }>());

export const lockService = createAction('[Lock] Lock Service', props<{ userId?: string; overwriteLock: boolean }>());
export const lockServiceCall = createAction('[Lock] Lock Service call', props<{ userId?: string }>());
export const unlockServiceCall = createAction('[Lock] Unlock Service call', props<{ userId?: string }>());
export const unlockService = createAction('[Lock] Unlock Service', props<{ userId?: string }>());
